
var $mainMenu,
$toggleMenu,
$toggleSubmenu,
$header,
$hasChildren;


$(document).ready(function($) {
    $toggleMenu = $('.js-toggle-menu');
    $mainMenu = $('.js-main-menu');
    $toggleSubmenu = $('.js-open-submenu');
    $header = $('.js-header');
    $hasChildren = $('.js-has-children');

    $toggleMenu.on('click', function() {
        $mainMenu.toggleClass('is-open');
        $(this).toggleClass('is-open');
    });

    $toggleSubmenu.on('click', function() {
        $(this).toggleClass('is-open');
        $(this).parent().find('.js-submenu').toggleClass('is-open');
    });

    $hasChildren.on('mouseover', function() {
        if (parseInt($(window).width()) > 992) {
            $header.addClass('has-overlay');
        }
    });

    $hasChildren.on('mouseleave', function() {
        $header.removeClass('has-overlay');
    });

    
});
